import 'react-notifications/lib/notifications.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	Button,
	Typography,
	Card,
	CardActions,
	CardContent,
} from '@material-ui/core';
import ChekkitTable from '../chekkit/ChekkitTable';

class ChekkitDashboard extends Component {
	async componentDidMount() {
		document.title = 'Chekkit | Chekkit Enterprise';
	}

	renderChekkitTable = () => <ChekkitTable />;

	render() {
		if (this.props.auth) {
			return this.renderChekkitTable();
		}

		return (
			<Card
				zdepth={1}
				style={{
					maxWidth: '350px',
					margin: 'auto',
					marginTop: '8px',
				}}
			>
				<CardContent>
					<Typography>Please Sign in to Chekkit</Typography>
				</CardContent>
				<CardActions>
					<Button href='/api/logout'>Sign In</Button>
				</CardActions>
			</Card>
		);
	}
}

function mapStateToProps(state) {
	return { error: state.error, auth: state.auth };
}

export default connect(mapStateToProps)(ChekkitDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboards/ChekkitDashboard.js